import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';
import { useApi, useAuth } from '@ibe/components';

import LoginService from './LoginService';
import LoginContext from './LoginContext';

export default function UseLoginService(): LoginService {
  const context = useContext(LoginContext);
  const loginService = useLocalObservable<LoginService>(() => context);
  const api = useApi();
  const auth = useAuth();

  loginService.setApi(api);
  loginService.setAuth(auth.authService);

  return loginService;
}
